import { Color } from '@persona-id/design-tokens';

const CaseIcon = ({ active }: { active: boolean }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      transform='scale(1.5) translate(4,4)'
    >
      <path
        d='M13.3334 4.66663H2.66671C1.93033 4.66663 1.33337 5.26358 1.33337 5.99996V12.6666C1.33337 13.403 1.93033 14 2.66671 14H13.3334C14.0698 14 14.6667 13.403 14.6667 12.6666V5.99996C14.6667 5.26358 14.0698 4.66663 13.3334 4.66663Z'
        stroke={active ? Color.CorePurple800 : Color.CorePurple600}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6667 14V3.33333C10.6667 2.97971 10.5262 2.64057 10.2762 2.39052C10.0261 2.14048 9.687 2 9.33337 2H6.66671C6.31309 2 5.97395 2.14048 5.7239 2.39052C5.47385 2.64057 5.33337 2.97971 5.33337 3.33333V14'
        stroke={active ? Color.CorePurple800 : Color.CorePurple600}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CaseIcon;
